module.exports = __webpack_public_path__ + "media/images/banner-assets/zh-cn/banner2-0729601f5a82f2d721109fc6a0cb74a0.jpg";